import {
  useSidePanel
} from "./chunk-SPOOX44O.mjs";
import {
  useSidebar
} from "./chunk-7NXFZEHC.mjs";

// src/layout-context.tsx
import * as React from "react";
import { useBeamer } from "@clara/beamer";
import { createContext } from "@clara/react-utils";
import { Flex } from "@clara/ui";
import { jsx } from "react/jsx-runtime";
var [LayoutContextProvider, useLayoutContext] = createContext({
  strict: true,
  name: "LayoutContext",
  errorMessage: "useLayoutContext: `context` is undefined. Seems you forgot to wrap layout components in `<Layout/>`"
});
function LayoutProvider(props) {
  const {
    referralProgram,
    beamerOptions,
    children,
    variant = "customer",
    hasMultientities = false,
    ...rest
  } = props;
  const sidePanel = useSidePanel();
  const sidebar = useSidebar();
  useBeamer(beamerOptions);
  const context = React.useMemo(
    () => ({
      sidePanel,
      sidebar,
      referralProgram,
      beamerOptions,
      variant,
      hasMultientities
    }),
    [
      sidePanel,
      sidebar,
      referralProgram,
      beamerOptions,
      variant,
      hasMultientities
    ]
  );
  return /* @__PURE__ */ jsx(LayoutContextProvider, { value: context, children: /* @__PURE__ */ jsx(Flex, { direction: "column", minHeight: "100vh", ...rest, children: props.children }) });
}
LayoutProvider.displayName = "LayoutProvider";

export {
  useLayoutContext,
  LayoutProvider
};
